import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { PageHeader } from "@/components/pawkt/PageHeader";
import { Loading } from "@/components/pawkt/Empty";
import { StatCard } from "@/components/pawkt/StatCard";
import { IndianRupee, TrendingDown, PiggyBank } from "lucide-react";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from "recharts";

export default function Reports() {
  const { data, isLoading } = useQuery({ queryKey: ["revenue-report"], queryFn: async () => (await api.get("/reports/revenue")).data });
  if (isLoading || !data) return <Loading />;
  const colors = ["#7C5CFC", "#8FA9E6", "#E9B872", "#F0B79E", "#4B9F55", "#B8A5FD", "#5837D8", "#E38A85"];

  return (
    <div>
      <PageHeader title="Reports" subtitle="Financial & operational intelligence" />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <StatCard testid="report-collected" label="Total Collected" value={inr(data.collected)} icon={IndianRupee} accent="emerald" />
        <StatCard testid="report-expenses" label="Total Expenses" value={inr(data.expenses)} icon={TrendingDown} accent="rose" />
        <StatCard testid="report-net" label="Net Profit" value={inr(data.net)} icon={PiggyBank} accent="indigo" />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <h3 className="font-display text-lg font-semibold text-slate-900 mb-4">Revenue by staff</h3>
        {data.by_staff.length === 0 ? <p className="text-sm text-slate-400 py-8 text-center">No data yet</p> : (
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={data.by_staff} margin={{ left: -10, top: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#F0E8DA" vertical={false} />
              <XAxis dataKey="name" tick={{ fontSize: 10, fill: "#7B6D62" }} axisLine={false} tickLine={false} angle={-15} textAnchor="end" height={60} />
              <YAxis tick={{ fontSize: 11, fill: "#B5A89D" }} axisLine={false} tickLine={false} tickFormatter={(v) => `₹${v / 1000}k`} />
              <Tooltip formatter={(v) => inr(v)} contentStyle={{ borderRadius: 14, border: "1px solid #EEE8DD", fontSize: 13 }} />
              <Bar dataKey="revenue" radius={[6, 6, 0, 0]}>
                {data.by_staff.map((_, i) => <Cell key={i} fill={colors[i % colors.length]} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
